import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Gracias a esta guía pude cambiar mi manera de hablarle antes y después de los partidos, y eso mejoró mucho su confianza.',
    name: 'Laura G.',
    color: 'bg-blue-100 text-blue-700'
  }, {
    quote: 'Me hizo ver que muchas veces, con buena intención, terminaba presionando más de lo que ayudaba. Fue un antes y un después.',
    name: 'Gustavo M.',
    color: 'bg-green-100 text-green-700'
  }, {
    quote: 'Encontré herramientas simples pero muy útiles para apoyar a mi hijo en los momentos en que más se frustraba con el fútbol.',
    name: 'Andrea C.',
    color: 'bg-purple-100 text-purple-700'
  }, {
    quote: 'Después de leerlo, pude acompañar a mi hijo con más calma, más criterio y menos ansiedad en cada partido.',
    name: 'Natalia P.',
    color: 'bg-lime-100 text-lime-700'
  }, {
    quote: 'Me ayudó a entender que competir mejor no siempre es meter más presión, sino dar un apoyo más inteligente y más humano.',
    name: 'Federico T.',
    color: 'bg-rose-100 text-rose-700'
  }, {
    quote: 'Nos sirvió mucho como familia porque empezamos a vivir el fútbol con menos tensión y con una mirada mucho más sana.',
    name: 'Paula N.',
    color: 'bg-teal-100 text-teal-700'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-226">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-228">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4" data-id="element-229">
            Lo que dicen las familias que ya lo tienen
          </h2>
          <div className="flex justify-center items-center gap-1 mb-4" data-id="element-230">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-6 h-6 fill-brand-amber text-brand-amber" data-id="element-231" />)}
          </div>
          <p className="text-lg text-brand-slate-light" data-id="element-232">
            Basado en la experiencia de cientos de padres.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-233">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-cream p-8 rounded-2xl relative shadow-sm border border-brand-slate/5 hover:shadow-md transition-shadow" data-id="element-234">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-brand-amber/20" data-id="element-235" />

              <div className="flex mb-4" data-id="element-236">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-4 h-4 fill-brand-amber text-brand-amber" data-id="element-237" />)}
              </div>

              <p className="text-brand-slate-light leading-relaxed mb-6 italic" data-id="element-238">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center mt-auto" data-id="element-239">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm mr-3 ${testimonial.color}`} data-id="element-240">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-241">
                  <p className="font-bold text-brand-slate" data-id="element-242">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-brand-slate-light" data-id="element-243">
                    Padre/Madre verificado
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}